module.exports = __webpack_public_path__ + "static/media/smallChart.0b383dea.svg";